var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Watch } from 'vue-property-decorator';
import VueDialog from "../../../../interface/IVueDialog";
import GoodService from '../../../../api/GoodService';
import BusinessGoodsPriceService from '../../../../api/BusinessGoodsPriceService';
import CategoryService from '../../../../api/CategoryService';
import LeftTree from './LeftTree';
import TabTable from './TabTable.vue';
import LicenseBindGoodsTabTable from './tabTable/LicenseBindGoods';
import SaleBindGoodsTabTable from './tabTable/SaleBindGoods';
import _ from 'lodash';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddGoods = (function (_super) {
    __extends(AddGoods, _super);
    function AddGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabTableComponent = 'tab-table';
        _this.showSelected = false;
        _this.treeData = [];
        _this.tableData = [];
        _this.total = 0;
        _this.curGoodNode = {};
        _this.activeName = '0';
        _this.selectRows = [];
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {
            keywords: '',
            dimension: 1
        };
        _this.dimension = 1;
        _this.dimension_lock = false;
        return _this;
    }
    AddGoods.prototype.watchShowStockGoods = function (newValue, oldValue) {
        this.search();
    };
    AddGoods.prototype.created = function () {
        console.log('this.tabTableComponent');
        console.log(this.tabTableComponent);
        this.service = GoodService.getInstance();
        this.categoryService = CategoryService.getInstance();
        this.businessGoodsPriceService = BusinessGoodsPriceService.getInstance();
        this.getLeftTree();
        if (this.showSelected) {
            this.selectedList = _.cloneDeep(this.addedDatas);
        }
        if (this.dimension) {
            this.formData.dimension = this.dimension;
        }
    };
    AddGoods.prototype.mounted = function () {
    };
    AddGoods.prototype.gitRightList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = __assign({}, this.formData);
        if (this.curGoodNode && this.curGoodNode.goods_type_id != '-1') {
            params = Object.assign({}, params, {
                goods_type: this.curGoodNode.goods_type_id
            });
        }
        var goods_ids, goods_format_ids;
        if (this.formData.dimension === 1) {
            goods_ids = (this.addedDatas || []).map(function (item) {
                return item.goods_id;
            });
            params.selected_goods_id = goods_ids.join(',');
        }
        else {
            goods_format_ids = (this.addedFormatDatas || []).map(function (item) {
                return item.goods_format_id;
            });
            params.selected_goods_format_ids = goods_format_ids.join(',');
        }
        this.businessGoodsPriceService.getGoodslist(Object.assign({}, params, pager)).then(function (res) {
            if (res.data.success) {
                if (res.data.data.length == 0 && pager.page > 1) {
                    _this.search();
                    return;
                }
                _this.tableData = res.data.data;
                _this.unSelectList = res.data.data;
                _this.total = res.data.total;
                _this.setSelected(true);
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddGoods.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        var select_key = this.dimension == 1 ? 'goods_id' : 'goods_format_id';
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), select_key);
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good[select_key] === currentRow[select_key]; })) {
            _.remove(this.selectedList, function (good) { return good[select_key] === currentRow[select_key]; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item[select_key] === good[select_key]; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
        });
    };
    AddGoods.prototype.handleClick = function (tab, event) {
        if (tab.name == "second") {
            this.setSelected();
        }
    };
    AddGoods.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.goods_id === good.goods_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddGoods.prototype.getLeftTree = function () {
        var _this = this;
        this.categoryService.getCategoryTree().then(function (res) {
            _this.treeData = res.data.data;
        });
    };
    AddGoods.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.gitRightList();
    };
    AddGoods.prototype.close = function () {
        this.$closeDialog();
    };
    AddGoods.prototype.save = function () {
        var data = _.uniqBy(this.selectedList, this.formData.dimension === 1 ? 'goods_id' : 'goods_format_id');
        this.$emit('save:ok', data, this.formData.dimension);
    };
    AddGoods.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
        this.gitRightList();
    };
    AddGoods.prototype.pageChange = function (pager) {
        this.gitRightList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    __decorate([
        Watch("formData.dimension")
    ], AddGoods.prototype, "watchShowStockGoods", null);
    AddGoods = __decorate([
        Component({
            components: {
                'left-tree': LeftTree,
                'tab-table': TabTable,
                'license-bind-goods-tab-table': LicenseBindGoodsTabTable,
                'sale-bind-goods-tab-table': SaleBindGoodsTabTable
            }
        })
    ], AddGoods);
    return AddGoods;
}(VueDialog));
export default AddGoods;
